"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// Components
const HighlightOff_1 = __importDefault(require("@material-ui/icons/HighlightOff"));
const react_clickout_handler_1 = __importDefault(require("react-clickout-handler"));
// Styled
const Styled = __importStar(require("./Styled"));
const Modal = (props) => {
    if (!props.showModal) {
        return null;
    }
    const [closingModal, setClosingModal] = (0, react_1.useState)(false);
    const testId = `${props.testId}-modal`;
    const closeModal = () => {
        setClosingModal(true);
        setTimeout(() => {
            setClosingModal(false);
            props.closeModal && props.closeModal();
        }, 300);
    };
    return ((0, jsx_runtime_1.jsxs)(react_clickout_handler_1.default, Object.assign({ onClickOut: props.closeModal ? closeModal : () => null, ignoredElements: props.ignoredClickoutElements || [] }, { children: [(0, jsx_runtime_1.jsx)(Styled.Background, { onClick: props.closeModal && closeModal, "data-testid": `${testId}-background` }), (0, jsx_runtime_1.jsxs)(Styled.Wrapper, Object.assign({ "data-testid": testId, className: `${testId}-modal modal-main`, closingModal: closingModal }, { children: [(props.title || props.closeModal) && ((0, jsx_runtime_1.jsxs)(Styled.Header, Object.assign({ className: `${testId}-header modal-header`, "data-testid": `${testId}-header` }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ "data-testid": `${testId}-title`, className: `${testId}-title modal-header-title` }, { children: props.title })), props.closeModal && ((0, jsx_runtime_1.jsx)(HighlightOff_1.default, { "data-testid": `${testId}-close`, onClick: closeModal, "aria-label": "fechar", role: "button" }))] }))), (0, jsx_runtime_1.jsx)(Styled.Content, Object.assign({ className: `${testId}-content modal-content` }, { children: props.children }))] })), (0, jsx_runtime_1.jsx)(Styled.GlobalStyle, { showModal: props.showModal })] })));
};
exports.Modal = Modal;
